import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SpatialToolkitComponent } from './spatial-toolkit.component';
import { GeojsonViewerComponent } from './geojson-viewer/geojson-viewer.component';
import { ClarityModule } from '@clr/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MapComponent } from './map/map.component';
import { CommonModule } from '@angular/common';
import { MonacoEditorModule } from '@materia-ui/ngx-monaco-editor';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [SpatialToolkitComponent, GeojsonViewerComponent, MapComponent],
  imports: [
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MonacoEditorModule,
    MatToolbarModule,
    FlexLayoutModule,
    MatCardModule,
  ],
  exports: [SpatialToolkitComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SpatialToolkitModule {}
